import type { MetaFunction } from "@remix-run/node";
import { RootLayout } from "~/components/layout/root-layout";
import { ModuleCard } from "~/components/cards/module-card";

export const meta: MetaFunction = () => {
  return [
    { title: "Deer AI - Rozpoznávání jeleních parohů" },
    { description: "Pokročilý systém pro analýzu a klasifikaci jeleních parohů pomocí umělé inteligence" },
  ];
};

export default function Index() {
  return (
    <RootLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="flex flex-col items-center gap-12 text-center">
          <header className="space-y-6">
            <h1 className="text-5xl font-bold tracking-tight text-gray-900 dark:text-gray-50">
              Deer AI
            </h1>
            <p className="max-w-2xl text-xl text-gray-600 dark:text-gray-300">
              Vítejte v systému Deer AI - systém pro analýzu a identifikaci jedinců jelena evropského.
              Náš systém využívá nejmodernější technologie umělé inteligence pro přesnou analýzu a identifikaci jedinců jelena evropského podle jejich paroží
            </p>
          </header>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <ModuleCard
              title="Katalog jelenů"
              description="Prohlížejte a spravujte katalog jelenů a jejich paroží"
              href="/app-catalog"
            />
            <ModuleCard
              title="Graf 2D paroží"
              description="Prohlížejte a prozkoumejte 2D grafy paroží z reálných fotografií"
              href="/app-chart2d"
            />
            <ModuleCard
              title="Analýza fotografie"
              description="Testovací aplikace pro segmentaci a skeletonizaci jeleního paroží"
              href="https://deer-ai-app-1.streamlit.app/"
              external
            />
          </div>
        </div>
      </div>
    </RootLayout>
  );
}
